<script setup lang="ts">
import { ref, watch } from "vue";
import { __color } from "@zyzgroup/core-web";
import { extractNumber } from "@zyzgroup/core-common";

// https://headlessui.com/v1/vue/switch

const props = withDefaults(
  defineProps<{
    init: boolean;
    width?: string;
    height?: string;
    padding?: string;
    colorPrimary?: string;
    colorBgOn?: string;
    colorBgOff?: string;
  }>(),
  {
    init: false,
    width: "44px",
    height: "26px",
    padding: "3px",
    colorPrimary: "#5a82f0",
    colorBgOn: "#efefef",
    colorBgOff: "#f5f5f5"
  }
);

const widthObj = extractNumber(props.width);
const heightObj = extractNumber(props.height);
const paddingObj = extractNumber(props.padding);
const roundLength = heightObj.number - paddingObj.number * 2 + heightObj.suffix;
const roundPositionStart = props.padding;
const roundPositionEnd =
  widthObj.number -
  extractNumber(roundPositionStart).number -
  extractNumber(roundLength).number +
  widthObj.suffix;
const emits = defineEmits<{
  (event: "change", value: boolean): void;
}>();

const enabled = ref(props.init);

watch(enabled, function () {
  emits("change", enabled.value);
});

function click() {
  enabled.value = !enabled.value;
}
</script>

<template>
  <div
    class="switch"
    @click="click"
    :style="[
      'width: ' + props.width,
      'height: ' + props.height,
      'background-color: ' + (enabled ? props.colorBgOn : props.colorBgOff)
    ]"
  >
    <span
      class="round"
      :style="[
        'width: ' + roundLength,
        'height: ' + roundLength,
        'background-color: ' +
          (enabled
            ? props.colorPrimary
            : __color.set(props.colorPrimary).lighten(0.5).toString()),
        'transform: translate(' +
          (enabled ? roundPositionEnd : roundPositionStart) +
          ', 0)'
      ]"
    />
  </div>
</template>

<style scoped>
.switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 9999px;
  box-sizing: border-box;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
}
.round {
  pointer-events: none;
  display: inline-block;
  box-sizing: border-box;
  border-radius: 9999px;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
